import { useCallback , useContext } from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import AuthContext from '../../store/auth-context';

const Card = styled.div`
    background-color: ${props => props.theme.palette.action.selected };
    color: #000;
    padding: 20px;
    border-radius: 8px;
    text-transform: capitalize;
    max-width: 100%;
    margin: 0 auto;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    @media (min-width: 768px) {
        padding: 30px;
    }
`;
const CardImg = styled.div`
    background-color: ${( { colorValue } ) => colorValue};
    height: 70px;
    border-radius:4px;
`;
const CardContent = styled.div`
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid ${ ( {theme} ) => theme.palette.divider };
    &:last-child {
        border-bottom: 0;
    }
`;

const Paragraph = styled.p`
    font-size: 22px;
    margin-top : 0;
    margin-bottom: 0;
    color: ${ ( { colorValue , theme } ) => colorValue ? colorValue : theme.palette.text.primary };
    text-align: left;
`
const Button = styled.button`
    font-size:17px;
    padding:15px 30px;
    background-color: ${ ( { primary , theme } ) => primary ? theme.palette.primary.dark : theme.palette.error.dark };
    color: #fff;
    border:0;
    outline: none;
    cursor: pointer;
    text-transform: capitalize;
    border-radius: 4px;
    transition: 0.3s ease-in-out;
    margin-left: 20px;
`

const Product = props => {

    const authCtx = useContext(AuthContext);

    const { history, buyProduct , id } = props;

    const detailsClickHandler = useCallback( ( id ) => {
        history.push(`${id}`)
    } , [ history ] ); 


    const buyProductHandler = ( id ) => {
        authCtx.isLoggedIn ?  buyProduct(id) : history.replace('/auth') ;
    }

    return (
        <Card >
            <CardImg colorValue={props.colorValue} />
            <CardContent >
                <div>
                    <Paragraph >{props.name} </Paragraph>
                    <Paragraph colorValue={ props.colorValue }>{props.colorValue}</Paragraph>
                </div>
                <Button primary onClick={ ( ) => detailsClickHandler(id) }  >details</Button>
            </CardContent>
            <CardContent >
                <Paragraph >{props.price}</Paragraph>
                <Button onClick={( ) => buyProductHandler(id )} >Buy</Button>
            </CardContent>
        </Card>
    )
}
export default withRouter(Product);